import * as React from "react";
import Box from "@mui/material/Box";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import FormHelperText from "@mui/material/FormHelperText";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import Chip from "@mui/material/Chip";
import { useNavigate, useLocation } from "react-router-dom";
import { IconButton, CircularProgress } from "@mui/material";
import { s3baseUrl } from "src/config/config";
import { EditExerciseApi } from "src/DAL/exercise/exercise";
import { AllActiveExerciseTypeListingApi } from "src/DAL/exerciseType/exerciseType";
import TagesToShow from "./component/modalToshowTages";
import { useEffect } from "react";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

const Input = styled("input")({
  display: "none",
});

export default function EditExercise() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [file, setProfileImage] = useState();
  const [fileNew, setProfileImageNew] = useState(false);
  const [exerciseType, setExerciseType] = useState([]);
  const [fileGif, setProfileImageGif] = useState();
  const [openDetails, setOpenDetails] = useState(false);
  const [exerciseTags, setExerciseTags] = useState([]);
  const [difficultyTags, setDifficultyTags] = useState([]);
  const [mainMuscleTags, setMainMuscleTags] = useState([]);

  const [inputs, setInputs] = useState({
    title: "",
    status: "",
    upload_type: "video",
    gif: "",
    type: "",
    programStatus: "",
    showStatus: "",
    image: {},
    accessType: "",
    videoUrl: "",
    short_description: "",
    detailed_description: "",
    video_show_Status: "",
    order: "",
    video_duration: "",
  });

  const handleChangeTags = (exerciseTags, difficultyTags, mainMuscleTags) => {
    setExerciseTags(exerciseTags);
    setDifficultyTags(difficultyTags);
    setMainMuscleTags(mainMuscleTags);
    setOpenDetails(false);
  };

  const handleDetails = (value) => {
    setOpenDetails(true);
  };

  const fileChangedHandler = (e) => {
    setProfileImage(URL.createObjectURL(e.target.files[0]));
    setProfileImageNew(true);
    setInputs({
      ...inputs,
      ["image"]: e.target.files[0],
    });
  };

  const fileChangedGif = (e) => {
    setProfileImageGif(URL.createObjectURL(e.target.files[0]));
    setInputs({
      ...inputs,
      ["gif"]: e.target.files[0],
    });
  };

  const urlPatternValidation = (URL) => {
    const regex = new RegExp(
      "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?",
    );
    return regex.test(URL);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const postTags = {
      difficulty: difficultyTags,
      main_muscle: mainMuscleTags,
      exercise: exerciseTags,
    };
    const formData = new FormData();
    if (!inputs.type) {
      enqueueSnackbar("Please select exercise type", { variant: "error" });
      return;
    }
    if (inputs.upload_type == "video") {
      if (urlPatternValidation(inputs.videoUrl) === false) {
        enqueueSnackbar("Enter Valid Video URL", { variant: "error" });
        return;
      }
    }
    if (inputs.upload_type == "gif") {
      if (!inputs.gif) {
        enqueueSnackbar("Upload Gif", { variant: "error" });
        return;
      }
    }
    if (fileNew && !inputs.image) {
      enqueueSnackbar("Upload Image", { variant: "error" });
      return;
    }
    formData.append("gif", inputs.upload_type == "gif" ? inputs.gif : "");
    formData.append("title", inputs.title);
    formData.append("type", inputs.type);
    formData.append("instructions", inputs.short_description);
    formData.append("status", inputs.status);
    formData.append("tags", JSON.stringify(postTags));
    formData.append(
      "video_url",
      inputs.upload_type == "video" ? inputs.videoUrl : "",
    );

    if (fileNew == true) {
      formData.append("image", inputs.image);
    }

    setIsLoading(true);
    const result = await EditExerciseApi(formData, state.exercise_slug);
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      navigate(-2);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const getExerciseTypes = async () => {
    const result = await AllActiveExerciseTypeListingApi();
    if (result.code === 200) {
      console.log(result, "dfkjsdahaf");
      setExerciseType(result?.exercise_types);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  useEffect(() => {
    getExerciseTypes();
  }, []);

  useEffect(() => {
    setExerciseTags(state?.tags?.exercise);
    setDifficultyTags(state?.tags?.difficulty);
    setMainMuscleTags(state?.tags?.main_muscle);
    setInputs((prevState) => ({
      ...prevState,
      ["gif"]: state?.gif_url,
      ["upload_type"]: state?.gif_url ? "gif" : "video",
      ["title"]: state?.title,
      ["status"]: state?.status,
      ["programStatus"]: state?.status,
      ["videoUrl"]: state?.video_url,
      ["short_description"]: state?.instructions,
      ["detailed_description"]: state?.detailed_description,
      ["video_duration"]: new Date(),
      ["image"]: state?.image?.thumbnail_1,
      ["type"]: state?.type,
    }));
  }, []);

  if (isLoading === true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <div className="container-fluid">
      <TagesToShow
        open={openDetails}
        setOpen={setOpenDetails}
        handleOk={handleChangeTags}
        exerciseTags={exerciseTags}
        difficultyTags={difficultyTags}
        mainMuscleTags={mainMuscleTags}
      />
      <div className="row mobile-margin display-flex">
        <div className="col-12 d-flex">
          <IconButton
            className="back-screen-button me-2"
            onClick={() => navigate(-1)}
          >
            <ArrowBackIcon />
          </IconButton>
          <h2>Edit Exercise</h2>
        </div>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
            <TextField
              id="outlined-basic"
              label="Exercise Name"
              variant="outlined"
              fullWidth
              name="title"
              required
              value={inputs.title}
              onChange={handleChange}
            />
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Exercise Type *
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="type"
                value={inputs.type}
                label="Exercise Type *"
                onChange={handleChange}
              >
                {exerciseType.map((item) => {
                  // console.log(item, "sdkjfjsd");
                  return (
                    <MenuItem value={item._id} key={item._id}>
                      {item.title}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Exercise Status *
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="status"
                value={inputs.status}
                label="Exercise Status *"
                onChange={handleChange}
              >
                <MenuItem value="true">Active</MenuItem>
                <MenuItem value="false">Inactive</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Upload Type *
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="upload_type"
                value={inputs.upload_type}
                label="Upload Type *"
                onChange={handleChange}
              >
                <MenuItem value="video">Video URL</MenuItem>
                <MenuItem value="gif">GIF</MenuItem>
              </Select>
            </FormControl>
          </div>
          {inputs?.upload_type == "video" ? (
            <div className="col-lg-6 col-md-6 col-sm-12 mt-4">
              <TextField
                id="outlined-basic"
                label="Landing Exercise Video Url"
                variant="outlined"
                fullWidth
                required
                name="videoUrl"
                value={inputs.videoUrl}
                onChange={handleChange}
              />
            </div>
          ) : (
            <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
              <div className="row w-100 div-style ms-0 pt-0">
                <div className="col-lg-5 col-md-5 col-sm-12">
                  <p className="">Upload Gif *</p>
                  <FormHelperText className="pt-0">
                    Gif Size(1000 X 670)
                  </FormHelperText>
                </div>
                <div className="col-lg-2 col-md-2 col-6">
                  {fileGif ? (
                    <img src={fileGif} height="50" />
                  ) : (
                    inputs?.gif && (
                      <img
                        className="image-border"
                        src={s3baseUrl + inputs.gif}
                        height="50"
                      />
                    )
                  )}
                </div>
                <div className="col-lg-5 col-md-5 col-6 text-end pt-2">
                  <label htmlFor="contained-button-file-1">
                    <Input
                      accept="image/GIF"
                      id="contained-button-file-1"
                      // multiple
                      type="file"
                      name="gif"
                      onChange={fileChangedGif}
                    />

                    <Button
                      className="small-contained-button"
                      startIcon={<FileUploadIcon />}
                      component="span"
                    >
                      Upload
                    </Button>
                  </label>
                </div>
              </div>
              {inputs.gif.name == "" ? (
                ""
              ) : (
                <p className="text-secondary">{inputs.gif.name}</p>
              )}
            </div>
          )}
          <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
            <div className="row w-100 div-style ms-0 pt-0">
              <div className="col-lg-5 col-md-5 col-12">
                <p className="">Upload Image *</p>
                <FormHelperText className="pt-0">
                  Image Size(1000 X 670) ("JPG", "JPEG", "PNG","WEBP")
                </FormHelperText>
              </div>
              <div className="col-lg-2 col-md-2 col-6">
                {file ? (
                  <img src={file} height="50" />
                ) : (
                  <img
                    className="image-border"
                    src={s3baseUrl + inputs.image}
                    height="50"
                  />
                )}
              </div>

              <div className="col-lg-5 col-md-5 col-6 text-end pt-2">
                <label htmlFor="contained-button-file">
                  <Input
                    accept=".jpg, .jpeg, .png, .webp"
                    id="contained-button-file"
                    multiple
                    type="file"
                    name="image"
                    onChange={fileChangedHandler}
                  />

                  <Button
                    className="small-contained-button"
                    startIcon={<FileUploadIcon />}
                    component="span"
                  >
                    Upload
                  </Button>
                </label>
              </div>
            </div>
            {inputs.image?.name == "" ? (
              ""
            ) : (
              <p className="text-secondary">{inputs?.image?.name}</p>
            )}
          </div>
          <div className="col-12 mt-3 d-flex align-items-start">
            <div className=""> Tags:</div>
            <Box sx={{ marginTop: 0 }}>
              {exerciseTags.map((tag) => (
                <Chip
                  key={tag}
                  label={tag}
                  size="small"
                  sx={{ marginX: 0.5, marginY: 0.5 }}
                />
              ))}
              {mainMuscleTags.map((tag) => (
                <Chip
                  key={tag}
                  label={tag}
                  size="small"
                  sx={{ marginX: 0.5, marginY: 0.5 }}
                />
              ))}
              {difficultyTags.map((tag) => (
                <Chip
                  key={tag}
                  label={tag}
                  size="small"
                  sx={{ marginX: 0.5, marginY: 0.5 }}
                />
              ))}
              <Button
                variant="text"
                size="small"
                sx={{
                  p: 0,
                  backgroundColor: "transparent",
                  ml: 2,
                  textTransform: "inherit",
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
                onClick={() => handleDetails()}
              >
                Add tags +
              </Button>
            </Box>
          </div>
          <div className="col-12 mt-5">
            <FormControl fullWidth>
              <TextField
                id="outlined-multiline-flexible"
                label="Short Description"
                multiline
                rows={6}
                required
                name="short_description"
                value={inputs.short_description}
                onChange={handleChange}
              />
              <FormHelperText>Maximum limit 500 characters</FormHelperText>
            </FormControl>
          </div>

          <div className="text-end mt-4">
            <button type="submit" className="small-contained-button">
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
